import { render, staticRenderFns } from "./tentative-seikyu.vue?vue&type=template&id=029f1f26&scoped=true&"
import script from "./tentative-seikyu.vue?vue&type=script&lang=js&"
export * from "./tentative-seikyu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029f1f26",
  null
  
)

export default component.exports